export default __webpack_public_path__ + "static/media/error.4861ae77.svg";